import { atom } from 'jotai/vanilla';

import { TeoCore } from '@/teoCore/TeoCore';
import type { TeoText } from '@/teoCore/text/TeoText';
import { useAtomValue } from '@/utils/jotai-svelte';
import { ActiveText$, onMountWithCore, teoCoreAtom } from '@/utils/teo-context';

interface Tab {
  title: string;
  id: number;
  teoText: TeoText;
}

function text2tab(text: TeoText): Tab {
  return {
    title: text.ui.state.title,
    id: text.id,
    teoText: text,
  };
}

const TabsAtom$ = teoCoreAtom((core) => core.texts.map(text2tab));
TabsAtom$.onMount = onMountWithCore(({ setSelf }, core) => {
  return core.events.addEventListener('textsChanged', () => {
    setSelf(core.texts.map(text2tab));
  });
});
export const useTabsValue = () => useAtomValue(TabsAtom$);

const ActiveTabIdAtom$ = atom((get) => get(ActiveText$).id);
export const useActiveTabId = () => useAtomValue(ActiveTabIdAtom$);

export const useTabsActions = () => {
  return {
    activateTab: (tabId: number) => {
      TeoCore.instance.switchText(tabId);
    },
    closeTab: (tabId: number) => {
      TeoCore.instance.removeText(tabId);
    },
    duplicateTab: (tabId: number) => {
      TeoCore.instance.duplicateText(tabId);
    },
    updateTabTitle: (tabId: number, title: string) => {
      TeoCore.instance.getText(tabId)?.updateTitle(title);
    },
    createNewTab: () => {
      TeoCore.instance.addText();
    },
  };
};

export const useTabs = () => [useTabsValue(), useTabsActions()] as const;
